import { axiosWrapperService } from "@/services/auth/axios-wrapper-service";
import { formatErrorMessage } from "@/utils/messageFormatter";

const state = () => {
  return {
    scheduledId: null,
    amount: null,
    isProcessing: false,
    errorMessage: "",
    validationErrors: [],
    editAmountSuccessCount: 0
  };
};

const getters = {
  amount: state => state.amount,
  scheduleId: state => state.scheduledId,
  errorMessage: state => state.errorMessage,
  validationErrors: state => state.validationErrors,
  editAmountSuccessCount: state => state.editAmountSuccessCount
};

const mutations = {
  setAmount(state, amount) {
    state.amount = amount;
  },

  setScheduleId(state, scheduleId) {
    state.scheduleId = scheduleId;
  },

  setErrorMessage(state, message) {
    state.errorMessage = message;
  },
  setValidationErrors(state, validationErrors) {
    state.validationErrors = validationErrors;
  },

  setIsProcessing(state, isProcessing) {
    state.isProcessing = isProcessing;
  },

  incrementEditAmountSuccessCount(state) {
    state.editAmountSuccessCount++;
  },

  clearErrors(state) {
    state.validationErrors = [];
    state.errorMessage = "";
  }
};

const actions = {
  submit: async ({ dispatch, state, commit }) => {
    commit("setIsProcessing", true);
    commit("clearErrors");

    const payload = {
      amount: state.amount
    };
    axiosWrapperService
      .axiosPost(`/paymentSchedules/${state.scheduleId}/editAmount`, payload)
      .then(() => {
        commit("incrementEditAmountSuccessCount");
        dispatch(
          "globalToastMessage/showSimpleToast",
          {
            message: `Amount Updated Successfully!`,
            type: "success"
          },
          { root: true }
        );
      })
      .catch(error => {
        if (error.response?.data?.errors) {
          commit("setValidationErrors", error.response.data.errors);
        } else {
          commit("setErrorMessage", formatErrorMessage(error));
        }
      })
      .finally(() => {
        commit("setIsProcessing", false);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
